var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"mei-toast-fade"}},[(_vm.show)?_c('div',{staticClass:"toast-container"},[(_vm.type!=='none')?_c('div',{staticClass:"toast-icon"},[_c('i',{class:['iconfont',_vm.iconClass]})]):_vm._e(),_c('div',{staticClass:"toast-text"},[_vm._v(_vm._s(_vm.text?_vm.text:'系统异常，请稍后重试'))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }